// extracted by mini-css-extract-plugin
module.exports = {"priceResponsive":"Price_priceResponsive__sM6WP"};